"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openHelpWidget = void 0;

var _sentry = require("./sentry");

/* globals hubspot */
var openHelpWidget = function openHelpWidget(options) {
  if (hubspot && hubspot.zorse && hubspot.zorse.openHelpWidget) {
    hubspot.zorse.openHelpWidget(options);
  } else {
    (0, _sentry.reportZorseUndefined)(options);
  }
};

exports.openHelpWidget = openHelpWidget;


//////////////////
// WEBPACK FOOTER
// ./js/utils/zorse.js
// module id = 784
// module chunks = 209 210 211 212